import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ValidationErrorService {
  private readonly _errors = signal<Record<string, string[]>>({});
  readonly errors = this._errors.asReadonly();

  set(errors: Record<string, string[]>) { this._errors.set(errors); }
  clear() { this._errors.set({}); }
}